<template>
    <div class="park">
        <Title chineseTitle="站点概况" englishTitle="The site survey"></Title>
        <div class="parkContent">
            <div class="body">
                <div class="progressContainer">
                    <div class="progressTitle">平均负载率</div>
                    <div class="progress">
                        <CircleProgress
                            :value="($store.getters.getTotal_p() / $store.state.receivingCapacity).toFixed(2)" />
                        <!-- :value="$store.state.load.length == 0 ? '--' : ($store.state.load.find(item => item.areaId == areaId).LoadPer/100).toFixed(2)" /> -->
                        <div class="progressValue">
                            {{isNaN($store.getters.getTotal_p() / $store.state.receivingCapacity * 100)? '--':($store.getters.getTotal_p() / $store.state.receivingCapacity * 100).toFixed(2) + '%'}}
                            <!-- {{$store.state.load.length == 0 ? '--' : ($store.state.load.find(item => item.areaId == areaId).LoadPer).toFixed(2) + "%"}} -->
                        </div>
                    </div>
                    <span class="progressText">{{'容量: ' + $store.state.receivingCapacity}}
                        <span style="font-size: 14rem"> kVA</span>
                        <!-- <span>{{'×' + $store.state.transformerNum}}</span> -->
                    </span>
                </div>
            </div>
            <div class="body">
                <Item title="电压等级" :data="$store.state.voltageClass?$store.state.voltageClass:'--' + '/0.4'" unit=" kV" />
            </div>
            <div class="body">
                <div class="itemContainer">
                    <div class="dataItem">
                        <div class="dataItem_title">框架断路器状态</div>
                        <div class="dataItem_data">
                            <!-- {{CloseAndOpen[0] + '/' + CloseAndOpen[1]}} -->
                            3 / 3
                        </div>
                    </div>
                    <div class="line"></div>
                    <div class="dataItem" v-if="transformList.length > 0">
                        <div class="dataItem_title">
                            <div class="select">
                                <div class="tit" @click="showList = !showList">
                                    {{transformList[currentDate].deviceName + '温度'}}
                                    <img style="margin-left:5px" src="@/assets/img/arrow.png">
                                </div>
                                <div class="date" v-if="showList">
                                    <div @click="currentDate = index, currentType = 0, showList = false"
                                        v-for="(item, index) in transformList" :key="index"
                                        :class="{active: index === currentDate && currentType === 0}">
                                        {{item.deviceName}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="dataItem_data">
                            <span style="margin-right:20px">A:
                                {{$store.state.MQTTObj[transformList[currentDate].subLoopUrl + '/Temperature_A'] == undefined ? '--' : parseFloat(Number($store.state.MQTTObj[transformList[currentDate].subLoopUrl + '/Temperature_A']).toFixed(2))}}
                                <span style="font-size:15rem">℃</span>
                            </span>
                            <span style="margin-right:20px">B:
                                {{$store.state.MQTTObj[transformList[currentDate].subLoopUrl + '/Temperature_B'] == undefined ? '--' : parseFloat(Number($store.state.MQTTObj[transformList[currentDate].subLoopUrl + '/Temperature_B']).toFixed(2))}}
                                <span style="font-size:15rem">℃</span>
                            </span>
                            <span>C:
                                {{$store.state.MQTTObj[transformList[currentDate].subLoopUrl + '/Temperature_C'] == undefined ? '--' : parseFloat(Number($store.state.MQTTObj[transformList[currentDate].subLoopUrl + '/Temperature_C']).toFixed(2))}}
                                <span style="font-size:15rem">℃</span>
                            </span>
                        </div>
                    </div>
                    <div class="dataItem" v-else>
                        <div class="dataItem_title">
                            <div class="select">
                                <div class="tit">{{'变压器温度'}}</div>
                            </div>
                        </div>
                        <div class="dataItem_data">
                            <span style="margin-right:20px">A: --<span style="font-size:15rem">℃</span></span>
                            <span style="margin-right:20px">B: --<span style="font-size:15rem">℃</span></span>
                            <span>C: --<span style="font-size:15rem">℃</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Title from "@/components/Title.vue";
    import Item from "@/components/Item";
    import CircleProgress from "@/components/CircleProgress";
    import {
        GetCurrentPowerInfo,
        GetAlarmList,
        GetCloseAndOpenNum,
        GetDeviceClassNum,
        GetAllTransformer,
    } from "@/components/Request";
    import {
        subscribebySubLoopUrl,
        unsubscribebySubLoopUrl
    } from "@/mqtt/index"

    export default {
        name: "SiteOverView",
        components: {
            Title,
            Item,
            CircleProgress
        },
        props: ["areaId"],
        data() {
            return {
                hasTransformer: false,
                timer: null,
                deviceNum: 0,
                transformList: [],
                currentType: 0,
                myChart: null,
                currentDate: 0,
                CloseAndOpen: [0, 0],
                showList: false,
            }
        },
        created() {
            this.getDeviceNum()
            this.getCloseAndOpenNum()
            GetAllTransformer({
                areaId: this.areaId,
            }).then(({
                data
            }) => {
                this.transformList = data.data.list.reverse()  
                this.transformList.forEach(item => {
                    subscribebySubLoopUrl([item.subLoopUrl + '/Temperature_A', item.subLoopUrl +
                        '/Temperature_B', item.subLoopUrl + '/Temperature_C'
                    ])
                })
            }).catch(err => {
                console.log(err)
            })
            this.timer = setInterval(() => {
                this.getCloseAndOpenNum();
            }, 10 * 1000);
        },
        watch: {
            areaId(newVal, oldVal) {
                this.timer && clearInterval(this.timer)
                this.timer && (this.timer = null)
                this.getCloseAndOpenNum()
                this.timer = setInterval(() => {
                    this.getCloseAndOpenNum();
                }, 10 * 1000);
            }
        },
        beforeDestroy() {
            this.timer && clearInterval(this.timer)
            this.timer && (this.timer = null)
            this.transformList.forEach(item => {
                unsubscribebySubLoopUrl([item.subLoopUrl + '/Temperature_A', item.subLoopUrl +
                    '/Temperature_B', item.subLoopUrl + '/Temperature_C'
                ])
            })
        },
        methods: {
            getCloseAndOpenNum() {
                GetCloseAndOpenNum({
                    areaId: this.areaId,
                }).then(({
                    data
                }) => {
                    this.CloseAndOpen = data.data.result
                }).catch(err => {
                    console.log(err)
                })
            },
            // 获取当前区域电柜数量和是否有变压器
            getDeviceNum() {
                GetDeviceClassNum({
                    areaId: this.areaId,
                }).then(({
                    data
                }) => {
                    let num = 0
                    data.data.result.map((item, index) => {
                        item.num && (num += item.num)
                    })
                    this.hasTransformer = data.data.result.find(item => item.type == '变压设备')
                    this.deviceNum = num
                }).catch(err => {
                    console.log(err)
                })

            }
        },
    };
</script>

<style lang="less" scoped>
    .progressContainer {
        width: 1960/192vw;
        height: 1500/108vh;
        background: #030d18;
        opacity: 0.75;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
    }

    .progressTitle {
        font-size: 18rem;
        font-weight: 400;
        color: #e6f8ff;
        opacity: 0.7;
    }

    .progress {
        width: 1200/192vw;
        height: 600/192vw;
        position: relative;
    }

    .progressValue {
        // margin-top: -300/108vh;
        position: absolute;
        bottom: -5rem;
        left: 50%;
        transform: translate(-50%, 0);
        font-size: 24rem;
        font-weight: bold;
        color: #ffffff;
    }

    .progressText {
        font-size: 14rem;
        font-weight: 400;
        color: #e6f3fd;
        opacity: 0.7;
        white-space: nowrap;
    }

    .itemContainer {
        width: 4000/192vw;
        height: 1500/108vh;
        background: rgba(3, 13, 24, 0.75);
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
    }

    .dataItem {
        height: 1000/108vh;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
    }

    .line {
        width: 10/192vw;
        height: 900/108vh;
        background: #ffffff;
        opacity: 0.15;
    }

    .dataItem_title {
        font-size: 14rem;
        color: #e6f8ff;
        position: relative;

        .select {
            position: relative;
            height: 100%;
            width: 100%;
            cursor: pointer;

            >div:first-child {
                height: 100%;
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                position: relative;
            }

            .date {
                width: 100%;
                max-height: 100vh;
                position: absolute;
                left: 0;
                margin-top: 5rem;
                background-color: #030D18;
                padding: 0 5px;
                overflow: hidden;
                display: block;
                z-index: 999;
                cursor: pointer;

                div {
                    text-align: center;
                    margin-bottom: 11px;
                    padding-top: 11px;
                    opacity: 0.75;

                    &:not(:first-child) {
                        border-top: 1px solid rgba(255, 255, 255, 0.15);
                    }

                    &:hover {
                        color: #0d94ff;
                    }
                }
            }
        }
    }

    .dataItem_data {
        font-size: 18rem;
        color: #e6f3fd;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
    }

    .park {
        position: fixed;
        top: 2500/108vh;
        left: 160/192vw;

        .parkContent {
            margin-left: 112/192vw;
            width: 4080/192vw;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

            .body {
                margin-left: 80/192vw;
                margin-top: 80/108vh;
                // overflow: hidden;
            }
        }
    }

    .data::-webkit-scrollbar {
        width: 50/192vw;
        height: 1px;
    }

    .data::-webkit-scrollbar-thumb {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(255, 255, 255, 0.7);
    }
</style>